import React, { Suspense } from 'react';
import componentKeyMappings from '../common/ComponentKeyMappings';
import APIs from '../common/APIs';
import defaultRestApi from '../common/RestApiInstance';
import { Row, Col } from "react-bootstrap";
import _ from "lodash";
import ErrorBoundary from '../components/ErrorBoundary';
import { ViewKeys } from "../common/Foundation";

export default class TemplateServices {

  static getTemplatesAPI = () => {
    return defaultRestApi.get(APIs.loadingTemplateURL())
  }

  static getTemplatesAPILocal = (skinName) => {
    return defaultRestApi.get(APIs.templateLoadURLLocal(skinName))
  }

  static initComponent = (nameComp, idKey, initialData, props) => {
    if (idKey == null) {
      idKey = nameComp;
    }
    const ComponentEle = componentKeyMappings[nameComp];
    if (ComponentEle != null) {
      return (
        <Suspense fallback={null}>
          <ErrorBoundary key={idKey + '_errorComp_' + nameComp} >
            <ComponentEle key={idKey} initialData={initialData} {...props}/>
          </ErrorBoundary>
        </Suspense>
      );
    }
    return null;
  }

  static async loadTemplateData() {
    const resp = await this.getTemplatesAPI()
    return this.initTemplateData(resp)
  }

  static async loadTemplateDataFromLocal(templateName) {
    const resp = await this.getTemplatesAPILocal(templateName);
    return this.initTemplateData(resp);
  }

  static initTemplateData(resp) {
    const templateData = {};
    let templDetail = {};
    if (typeof resp.data.template === 'string') {
      templDetail = JSON.parse(resp.data.template);
    } else {
      templDetail = resp.data.template;
    }
    templateData.attributes = _.get(resp, 'data.globalAttribute', {});

    const initDataForComps =  _.get(resp, 'data.initDataForComps', {});
    templateData.allComponents = [];
    this.pushComps(templateData.allComponents, templDetail.headerContainer.formal);
    this.pushComps(templateData.allComponents, templDetail.headerContainer.scroll);
    this.pushComps(templateData.allComponents, templDetail.headerContainer.sideBar);
    templateData.headerContainer = templDetail.headerContainer;

    templateData.isNonNeader = false;
    if (templDetail.templateType === 'iFrame') {
      templateData.isNonNeader = true;
    }

    //-----------Body-------------------------//
    templateData.bodyContainer = templDetail.bodyContainer || {};
    const bodyContainer = templateData.bodyContainer;
    _.forEach(bodyContainer, (pages, viewKey) => {
      _.forEach(pages, (positionsInPages, pageKey) => {
        _.forEach(positionsInPages, (components, positionsInPageKey) => {
          this.pushComps(templateData.allComponents, components);
        });
      });
    });

    //--------------Footer-------------------//
    const footerComps = (templDetail.footerContainer);
    _.forEach(footerComps, (component, viewKey) => {
      this.pushComps(templateData.allComponents, component);
    });

    this.updateCompsInitialData(templateData.allComponents, initDataForComps)
    templateData.footerCompNames = footerComps;
    templateData.compactViewNotify = _.get(templDetail, "compactViewNotify", {})
    templateData.cssFile = _.get(templDetail.cssFiles, "[0]", {});
    templateData.cssFontFile = _.get(templDetail.cssFontFiles, "[0]", {}).name;
    templateData.initDataForSkin = this.loadSharedComponentData('SharedComponent', resp.data.initDataForComps);
    return templateData;
  }

  static loadSharedComponentData(sharedComponentName, dataAllComps) {
    let initDataForSkin = [];
    _.forOwn(dataAllComps, function (comp, key) {
      if (comp.componentName === sharedComponentName) {
        initDataForSkin = comp.initialData
        return false;
      }
    });
    return initDataForSkin
  }

  /**
   * convert to React Components from data json
   * 
   */
  static listComponentsByData(data, auth, props) {
    // const objData = CommonUtil.convertMobxObjToJsonObj(data);
    const comps = Object.keys(data);
    const listComponents = comps.map((key) => {
      const compName = data[key].componentName;
      const idKey = compName;
      const initialData = data[key].initialData || {};
      const compEle = this.initComponent(compName, idKey, initialData, props)
      return {
        component: compEle,
        gridColumn: data[key].gridColumn,
        compName: compName
      }
    });

    if (_.isEmpty(listComponents)) {
      return (<div key={'component_empty'} />)
    }
    const viewRow = [];
    let viewComponentsNoGrid = [];
    let viewComponents = [];
    let lengthGrid = 0;

    for (let i = 0; i < listComponents.length; i++) {
      lengthGrid += listComponents[i].gridColumn;
      const isNextHaveGrid = listComponents[i + 1] != null && listComponents[i + 1].gridColumn != null;
      if (listComponents[i].gridColumn != null) {
        viewComponents.push(
          <Col key={"col-" + i} sm={listComponents[i].gridColumn} className={listComponents[i].compName + '_container'}>
            {listComponents[i].component}
          </Col>
        )
      }
      else {
        viewComponentsNoGrid.push(
          <Col key={"col-" + i} className={listComponents[i].compName + '_container'}>
            {listComponents[i].component}
          </Col>
        )

        if (isNextHaveGrid) {
          if (viewComponentsNoGrid.length > 0) {
            viewComponents.push(
              <div className={'components_nogrid'} key={'component_key_' + i}>
                {viewComponentsNoGrid}
              </div>
            )
            viewComponentsNoGrid = [];
          }
        }
      }
      const isNextEleHaveGrid12 = isNextHaveGrid && (listComponents[i + 1].gridColumn == 12);
      if (isNextEleHaveGrid12 || lengthGrid >= 12 || i === listComponents.length - 1) {
        lengthGrid = 0;
        viewRow.push(this.newRowComponent(viewComponents, i));
        viewComponents = [];
      }
    }
    return viewRow;
  }

  static newRowComponent(componentInRow, key) {
    return (
      <Row key={"row-" + key}>
        <div className="container">
          {componentInRow.map(comp => {
            return comp
          })}
        </div>
      </Row>
    )
  }

  /**
   * convert to React Components from data json
   * 
   */
  static listComponentsByDataNoGrid(data, props) {
    // const objData = CommonUtil.convertMobxObjToJsonObj(data);
    const comps = Object.keys(data)
    
    return comps.map((key) => {
      const compName = data[key].componentName;
      const idKey = compName;
      const initialData = data[key].initialData || {};
      const compEle = this.initComponent(compName, idKey, initialData, props);
      return (
        <div
          key={key + '_components_nogrid'}
          className={compName + '_container'}
        >
          {compEle}
        </div>
      );
    });
  }

  /**
   * push new array to exist array
   */
  static pushComps(orgComps, newDataComps) {
    if (Array.isArray(newDataComps) && newDataComps.length > 0) {
      _.forOwn(newDataComps,(comp, key) =>  {
        orgComps.push(comp);
      });
    }
  }

  /**
   * updateCompsInitialData
   * Add InitialData into each components
   *
   *
   */
  static updateCompsInitialData(dataComps, initDataForComps) {
    const newComps = [];
    const mapNameAndIntialData = new Map();

    _.forOwn(initDataForComps, (comp, key) => {
      if (typeof comp.initialData === 'string') {
        mapNameAndIntialData.set(comp.componentName, JSON.parse(comp.initialData))
      } else {
        mapNameAndIntialData.set(comp.componentName, comp.initialData)
      }
    });

    _.forOwn(dataComps, (comp, key) => {
      if (mapNameAndIntialData.get(comp.componentName) != null) {
        comp.initialData = mapNameAndIntialData.get(comp.componentName)
      }
      newComps.push(comp);
    });
    dataComps = newComps;
  }

  /**
   * load Componenta By Array Names In TemplateStore
   */
  static loadComponentByNameInTemplateStore(compNames, allCompsLayoutTemplateStore) {
    const compDetects = [];
    _.forOwn(allCompsLayoutTemplateStore, (comp, key) => {
      if (compNames.indexOf(comp.componentName) > -1) {
        compDetects.push(comp);
      }
    });
    return this.listComponentsByDataNoGrid(compDetects)
  }

  /**
   * load Components By array names in template
   */
  static async loadComponentByNameInTemplate(compNames, templateName) {
    return this.loadComponentsInTemplate(templateName).then(res => {
      const templateData = res;
      const allCompsLayoutTemplateStore = templateData.allComponents;
      return this.loadComponentByNameInTemplateStore(compNames, allCompsLayoutTemplateStore);
    });
  }

  /**
   * convert to React Components from data json
   * 
   */
  static listDataCompsByContainer(temmplateData, container, view, page, position) {
    let currentView = view;
    if (temmplateData[container] == null) {
      return [];
    }
    if (temmplateData[container][currentView] == null) {
      //get asiaView if page have only asiaView
      currentView = 'compactView';
    }
    if (temmplateData[container][currentView] == null ||
      temmplateData[container][currentView][page] == null ||
      temmplateData[container][currentView][page][position] == null
    ) {
      return [];
    }

    return temmplateData[container][currentView][page][position];
  }
  /**
   * check fixed header by Page
   * check show button back to top
   */
  static isThisPageFixedHeader(props) {
    const { templateData, currentViewContainer, currentPageContainer } = props;
    let isFixed = true;
    try {
      if (typeof templateData.bodyContainer[currentViewContainer][currentPageContainer]['fixedHeader'] !== 'undefined') {
        isFixed = templateData.bodyContainer[currentViewContainer][currentPageContainer]['fixedHeader'];
      }
    } catch (error) {

    }
    return isFixed;

  }

  /**
   * listDataCompsByContainerPosition
   */
  static listDataCompsByContainerPosition(templateData, view, page, container, position) {
    return this.listDataCompsByContainer(templateData, container, view, page, position);
  }

  /**
   * Detect view asia or euro or classic base on URL
   */
  static getViewByURLPath = () => {
    const strUrl = window.location.href.replace(process.env.REACT_APP_ROUTER_BASE, "");
    const viewOnURL = _.get(strUrl.split("/"), '[4]', '');
    return ViewKeys[viewOnURL] || ViewKeys.compact;
  }
}


// WEBPACK FOOTER //
// ./src/app/services/TemplateServices.js